import ProfileHeader from '../features/profile/ProfileHeader';
import ProfileDetails from '../features/profile/ProfileDetails';

function UserProfile() {
    return (
        <div className='pt-9 px-9'>
            <ProfileHeader />
            <ProfileDetails />
        </div>
    );
}

export default UserProfile;
